import Vue from 'vue'
import Router from 'vue-router'


import LayoutHome from '@/components/Layout_Home'
import LayoutMini from '@/components/LayoutMini'
import LayoutWechat from '@/components/LayoutWechat'
import LayoutImage from '@/components/LayoutImage'


import Index from '@/pages/index'
import Login from '@/pages/account/login'



Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      // redirect: '/app/',
      redirect: '/Login'
    },
    {
      path: '/agent_use_new',
      name: 'AgentUse',
      component: () => import('@/pages/aigc/text_generate4'),
      meta: {requireAuth: false},
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    // {
    //   path: '/verify',
    //   name: 'Verify',
    //   component: Verify,
    //   meta: {requireAuth: true},
    // },


    {
      path: '/app',
      name: 'app',
      component: LayoutHome,
      children: [

        {
          path: '',
          component: Index,
          name: 'Index',
          meta: {requireAuth: false},
        },
        {
          path: 'index',
          component: Index,
          name: 'Index',
          meta: {requireAuth: false},
        },



        {
          path: 'role',
          name: 'Role',
          component: () => import('@/pages/account/role'),
          meta: {requireAuth: true},
        },
        {
          path: 'manager',
          name: 'Manager',
          component: () => import('@/pages/account/manager'),
          meta: {requireAuth: true},
        },

        {
          path: 'account_update',
          name: 'AccountUpdate',
          component: () => import('@/pages/account/account_update'),
          meta: {requireAuth: true},
        },

        {
          path: 'wallet',
          name: 'Wallet',
          component: () => import('@/pages/account/wallet'),
          meta: {requireAuth: true},
        },

        {
          path: 'system_manage',
          name: 'SystemManage',
          component: () => import('@/pages/system/system_manage'),
          meta: {requireAuth: true},
        },

        //  {
        //   path: 'chain_config',
        //   name: 'ChainConfig',
        //   component: () => import('@/pages/manage/chain_config'),
        //   meta: {requireAuth: true},
        // },

        {
          path: 'chain',
          name: 'Chain',
          component: () => import('@/pages/manage/chain'),
          meta: {requireAuth: true},
        },

        {
          path: 'chain_update',
          name: 'ChainUpdate',
          component: () => import('@/pages/manage/chain_update'),
          meta: {requireAuth: true},
        },

        {
          path: 'user',
          name: 'User',
          component: () => import('@/pages/manage/user'),
          meta: {requireAuth: true},
        },
        {
          path: 'user_board',
          name: 'UserBoard',
          component: () => import('@/pages/manage/user_board'),
          meta: {requireAuth: true},
        },
        {
          path: 'recharge_list',
          name: 'RechargeList',
          component: () => import('@/pages/manage/point_recharge_list'),
          meta: {requireAuth: true},
        },




        {
          path: 'menu',
          name: 'Menu',
          component: () => import('@/pages/manage/menu'),
          meta: {requireAuth: true},
        },

        {
          path: 'page',
          name: 'Page',
          component: () => import('@/pages/manage/page'),
          meta: {requireAuth: true},
        },

        {
          path: 'page_decorate',
          name: 'PageDecorate',
          component: () => import('@/pages/manage/page_decorate'),
          meta: {requireAuth: true},
        },

        {
          path: 'poster',
          name: 'Poster',
          component: () => import('@/pages/manage/poster'),
          meta: {requireAuth: true},
        },

        {
          path: 'poster_decorate',
          name: 'PosterDecorate',
          component: () => import('@/pages/manage/poster_decorate'),
          meta: {requireAuth: true},
        },


        {
          path: 'app_manage',
          name: 'AppManage',
          component: () => import('@/pages/manage/app'),
          meta: {requireAuth: true},
        },


        {
          path: 'sms_tpl_manage',
          name: 'SmsTplManage',
          component: () => import('@/pages/manage/sms_tpl'),
          meta: {requireAuth: true},
        },

        {
          path: 'plan_manage',
          name: 'PlanManage',
          component: () => import('@/pages/manage/plan'),
          meta: {requireAuth: true},
        },


        {
          path: 'im',
          component: () => import('@/pages/im/index'),
          name: 'IM-PC',
          meta: {requireAuth: false},
        },

        // {
        //   path: 'im_chat',
        //   component: () => import('@/pages/im/im_chat_detail'),
        //   name: 'IM',
        //   meta: {requireAuth: false},
        // },




        {
          path: 'doc',
          name: 'Doc',
          component:  () => import('@/pages/aigc/doc'),
          meta: {requireAuth: true},
        },

        {
          path: 'aigc_template',
          name: 'AigcTemplate',
          component:  () => import('@/pages/aigc/template'),
          meta: {requireAuth: true},
        },


        {
          path: 'aigc_model',
          name: 'AigcModel',
          component:  () => import('@/pages/aigc/model'),
          meta: {requireAuth: true},
        },

        {
          path: 'aigc_plugin',
          name: 'AigcPlugin',
          component:  () => import('@/pages/aigc/plugin'),
          meta: {requireAuth: true},
        },

        {
          path: 'aigc_workflow',
          name: 'AigcFlow',
          component:  () => import('@/pages/aigc/workflow'),
          meta: {requireAuth: true},
        },


        // {
        //   path: 'text',
        //   name: 'AigcText',
        //   component: () => import('@/pages/aigc/text_create')
        // },


        {
          path: 'image_2_text',
          name: 'Image2Text',
          component: () => import('@/pages/aigc/image_2_text')
        },

        {
          path: 'tts',
          name: 'TTS',
          component: () => import('@/pages/aigc/voice_create')
        },

        {
          path: 'video_create',
          name: 'VideoCreate',
          component: () => import('@/pages/aigc/video')
        },

        {
          path: 'video_batch_clip',
          name: 'VideoClip',
          component: () => import('@/pages/aigc/video_clip')
        },

        {
          path: 'video_matrix',
          name: 'VideoMatrix',
          component: () => import('@/pages/aigc/video_matrix')
        },


        // {
        //   path: 'voice_chat',
        //   name: 'VoiceChat',
        //   component: () => import('@/pages/aigc/voice_chat_custom')
        // },


        {
          path: 'agent_manage',
          name: 'Agent',
          component: () => import('@/pages/aigc/agent')
        },

        {
          path: 'agent_add',
          name: 'AgentAdd',
          component: () => import('@/pages/aigc/agent_add2')
        },

        {
          path: 'agent_use',
          name: 'AgentUse',
          component: () => import('@/pages/aigc/text_generate3')
        },

       


        {
          path: 'aigc_image',
          name: 'AigcImage',
          component: () => import('@/pages/aigc/aigc_image')
        },







        {
          path: 'shop',
          name: 'Shop',
          component: () => import('@/pages/mall/shop'),
          meta: {requireAuth: true},
        },


        {
          path: 'product',
          name: 'Product',
          component: () => import('@/pages/mall/product'),
          meta: {requireAuth: true},
        },


        {
          path: 'product_item',
          name: 'ProductItem',
          component: () => import('@/pages/mall/product_item'),
          meta: {requireAuth: true},
        },

        {
          path: 'service',
          name: 'Service',
          component: () => import('@/pages/mall/service'),
          meta: {requireAuth: true},
        },
        {
          path: 'coupon',
          name: 'Coupon',
          component: () => import('@/pages/mall/coupon'),
          meta: {requireAuth: true},
        },

        {
          path: 'card',
          name: 'Card',
          component: () => import('@/pages/mall/card'),
          meta: {requireAuth: true},
        },


        {
          path: 'order',
          name: 'OrderManage',
          component: () => import('@/pages/mall/order_list'),
          meta: {requireAuth: true},
        },

        {
          path: 'shop_indicator',
          name: 'ShopIndicator',
          component: () => import('@/pages/mall/indicator'),
          meta: {requireAuth: true},
        },

        {
          path: 'order_report',
          name: 'OrderReport',
          component: () => import('@/pages/mall/order_report'),
          meta: {requireAuth: true},
        },


        {
          path: 'order_comment',
          name: 'OrderComment',
          component: () => import('@/pages/mall/order_comment'),
          meta: {requireAuth: true},
        },


        {
          path: 'sale',
          name: 'Sale',
          component: () => import('@/pages/mall/sale'),
          meta: {requireAuth: true},
        },

        {
          path: 'freight',
          name: 'Freight',
          component: () => import('@/pages/mall/freight_template'),
          meta: {requireAuth: true},
        },

        {
          path: 'discount',
          name: 'Discount',
          component: () => import('@/pages/mall/discount'),
          meta: {requireAuth: true},
        },


        {
          path: 'wechat_pay',
          name: 'WechatPay',
          component: () => import('@/pages/wechat/wechat_pay'),
          meta: {requireAuth: true},
        },


        {
          path: 'article',
          name: 'Article',
          component: () => import('@/pages/article/article'),
          meta: {requireAuth: true},
        },





        {
          path: 'examine_library',
          name: 'ExamineLibrary',
          component: () => import('@/pages/job/examine_library')
        },

        {
          path: 'interview',
          name: 'Interview',
          component: () => import('@/pages/job/interview_list')
        },


      ]
    },


    {
      path: '/app_image',
      name: 'app_image',
      component: LayoutHome,
      children: [


        {
          path: 'image_segment',
          name: 'image_segment',
          component: () => import('@/pages/aigc/image_segment')
        },


        {
          path: 'image_erase',
          name: 'image_erase',
          component: () => import('@/pages/aigc/image_erase')
        },

        {
          path: 'image_bg_change',
          name: 'image_bg_change',
          component: () => import('@/pages/aigc/image_bg_change')
        },

        {
          path: 'image_scale',
          name: 'image_scale',
          component: () => import('@/pages/aigc/image_scale')
        },

        {
          path: 'image_zoom',
          name: 'image_zoom',
          component:() => import('@/pages/aigc/image_zoom')
        },


        {
          path: 'image_scene',
          name: 'image_scene',
          component: () => import('@/pages/aigc/image_scene')
        },


        {
          path: 'image_copy',
          name: 'image_copy',
          component: () => import('@/pages/aigc/image_copy')
        },

        {
          path: 'image_common',
          name: 'image_common',
          component: () => import('@/pages/aigc/image_common')
        },

        {
          path: 'image_merge',
          name: 'image_merge',
          component: () => import('@/pages/aigc/image_merge')
        },

        {
          path: 'image_replace',
          name: 'image_replace',
          component: () => import('@/pages/aigc/image_merge')
        },

        {
          path: 'model_replace',
          name: 'model_replace',
          component: () => import('@/pages/aigc/image_merge')
        },


        {
          path: 'virtual_model',
          name: 'virtual_model',
          component: () => import('@/pages/aigc/virtual_model')
        },
        {
          path: 'virtual_model2',
          name: 'virtual_model2',
          component: () => import('@/pages/aigc/virtual_model')
        },

        {
          path: 'try_on',
          name: 'try_on',
          component: () => import('@/pages/aigc/try_on')
        },

        {
          path: 'model_bg_change',
          name: 'model_bg_change',
          component: () => import('@/pages/aigc/model_bg_change')
        },

        {
          path: 'product_bg_change',
          name: 'product_bg_change',
          component: () => import('@/pages/aigc/image_bg_change')
        },


      ]
    },


    {
      path: '/app_mini',
      name: 'app_mini',
      component: LayoutMini,
      children: [
        {
          path: 'home',
          component: () => import('@/pages/app/home'),
          name: 'AppMiniHome',
          meta: {requireAuth: false},
        },

        {
          path: 'consult',
          component: () => import('@/pages/app/consult'),
          name: 'AppMiniConsult',
          meta: {requireAuth: false},
        },

        {
          path: 'profile',
          component: () => import('@/pages/app/profile'),
          name: 'AppMiniProfile',
          meta: {requireAuth: false},
        },
      ]
    },


    {
      path: '/app_workflow',
      name: 'app_workflow',
      component: LayoutImage,
      children: [
        {
          path: 'design',
          component: () => import('@/pages/aigc/workflow/design'),
          name: 'WorkflowDesign',
          meta: {requireAuth: false},
        },
      ]
    },

    {
      path: '/app_wechat',
      name: 'app_wechat',
      component: LayoutWechat,
      children: [
        {
          path: 'chat',
          component: () => import('@/pages/app/chat'),
          name: 'AppMiniChat',
          meta: {requireAuth: false},
        },

        {
          path: 'video',
          component: () => import('@/pages/app/video'),
          name: 'AppMiniVideo',
          meta: {requireAuth: false},
        },

        {
          path: 'voice',
          component: () => import('@/pages/app/voice'),
          name: 'AppMiniVoice',
          meta: {requireAuth: false},
        },

        {
          path: 'voice_chat',
          component: () => import('@/pages/aigc/voice_chat_custom'),
          name: 'AppMiniVoiceChat',
          meta: {requireAuth: false},
        },

        {
          path: 'image',
          name: 'AppMiniImage',
          component: () => import('@/pages/aigc/aigc_image')
        },

        {
          path: 'doc',
          component: () => import('@/pages/aigc/doc'),
          name: 'AppMiniDoc',
          meta: {requireAuth: false},
        },


        {
          path: 'home',
          component: () => import('@/pages/app/home'),
          name: 'AppMiniHome',
          meta: {requireAuth: false},
        },


        {
          path: 'live',
          component: () => import('@/pages/app/live'),
          name: 'AppLive',
          meta: {requireAuth: false},
        },

        {
          path: 'interview',
          component: () => import('@/pages/job/interview'),
          name: 'Interview',
          meta: {requireAuth: false},
        },

        {
          path: 'interview_test',
          component: () => import('@/pages/job/interview_test'),
          name: 'InterviewTest',
          meta: {requireAuth: false},
        },

        {
          path: 'im_voice',
          component: () => import('@/pages/app/im_voice_chat'),
          name: 'ImVoiceChat',
          meta: {requireAuth: false},
        },


        // {
        //   path: 'im',
        //   component: () => import('@/pages/im/im_chat_list'),
        //   name: 'Im',
        //   meta: {requireAuth: false},
        // },
        //
        // {
        //   path: 'im_chat',
        //   component: () => import('@/pages/im/im_chat_detail'),
        //   name: 'ImChat',
        //   meta: {requireAuth: false},
        // },

      ]
    },


  ],
  // mode:'history'
})

